export default {"src":"/_next/static/media/find_template.d6fbe07e.svg","height":500,"width":500};